import { render } from "./index.vue?vue&type=template&id=7ec785da&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Companies/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ec785da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ec785da', __exports__)) {
    api.reload('7ec785da', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=7ec785da&ts=true", () => {
    api.rerender('7ec785da', render)
  })

}


export default __exports__